import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Loader } from "../../../../../components";

import "./DeleteJobConfirmationModal.scss";

class DeleteJobConfirmationModal extends Component {
	constructor(props) {
		super(props);
		const { lang } = global;
		this.state = {
			reason: "",
			note: "",
			isValid: true,
		};

		this.reasonPresets = [
			{
				value: 1,
				label: lang.t("Inclement Weather"),
				description: lang.t("Cancelled due to Inclement Weather"),
			},
			{
				value: 2,
				label: lang.t("Rescheduled"),
				description: lang.t("Rescheduled for another day"),
			},
			{
				value: 3,
				label: lang.t("Equipment not received"),
				description: lang.t("Equipment for Event has not arrived"),
			},
			{
				value: 4,
				label: lang.t("Client Cancelled"),
				description: lang.t("The Client has cancelled the job"),
			},
			{
				value: 5,
				label: lang.t("Department Cancelled"),
				description: "The Department has cancelled the job",
			},
			{
				value: 6,
				label: lang.t("Admin Leave"),
				description: lang.t("The Department has cancelled the job"),
			},
			{
				value: 7,
				label: lang.t("State of Emergency"),
				description: lang.t("Job cancelled due to a State of Emergency"),
			},
			{ value: 8, label: lang.t("Other"), description: "" },
		];
	}

	onNoteChange = ({ target: { value } }) => this.setState({ note: value });

	onReasonChange = e => {
		const { target } = e;
		const note = this.reasonPresets.find(
			({ value }) => value.toString() === target.value,
		).description;
		this.setState({ reason: target.value, note });
	};

	onCancel = () => {
		const { onHide } = this.props;
		this.setState(
			{
				reason: "",
				note: "",
				isValid: true,
			},
			() => {
				onHide();
			},
		);
	};

	onConfirm = () => {
		const { note } = this.state;
		const { handleDeleteJob } = this.props;

		if (!note) {
			this.setState({ isValid: false });
			return;
		}
		handleDeleteJob(note);

		this.setState({
			reason: "",
			note: "",
			isValid: true,
		});
	};

	render() {
		const { lang } = global;
		const { modalDetails } = this.props;
		const { reason, note, isValid } = this.state;
		return (
			<Modal
				id="deletejob-confirmation-modal"
				show={modalDetails.show}
				onHide={this.onCancel}
			>
				<Modal.Header closeButton>
					<Modal.Title>{`${lang.t("Delete Job")}`}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div>
						{`${lang.t("dynamic.Are you sure you want to delete", {
							subject: modalDetails.deleteAll
								? lang.t("these jobs")
								: lang.t("this job"),
						})} 
							${lang.t("Any changes, including notes and job assignments, will be lost_")}`}
					</div>
					<div className="form-group">
						<label htmlFor="select-reason">{lang.t("Please specify a reason")}</label>
						<select
							name="select-reason"
							className="form-control"
							onChange={this.onReasonChange}
							value={reason}
						>
							<If condition={reason === ""}>
								<option value="">{lang.t("Select Reason")}</option>
							</If>
							<For
								each="reason"
								of={this.reasonPresets}
							>
								<option
									key={`reason_${reason.value}`}
									value={reason.value}
								>
									{reason.label}
								</option>
								)
							</For>
						</select>
					</div>
					<div className={`form-group ${!isValid ? "has-error" : ""}`}>
						<label htmlFor="msg-reason">{lang.t("Send a message to officers")}</label>
						<textarea
							name="msg-reason"
							className="form-control"
							onChange={this.onNoteChange}
							value={note}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-default"
						onClick={this.onCancel}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={this.onConfirm}
					>
						{lang.t("Delete Job")}
					</button>
				</Modal.Footer>
				<Loader
					active={modalDetails.loading}
					size="small"
				/>
			</Modal>
		);
	}
}

DeleteJobConfirmationModal.propTypes = {
	modalDetails: PropTypes.object,
	onHide: PropTypes.func,
	handleDeleteJob: PropTypes.func,
};

DeleteJobConfirmationModal.defaultProps = {
	modalDetails: {},
	onHide: undefined,
	handleDeleteJob: undefined,
};

export default DeleteJobConfirmationModal;
